import type { Entity as WorkbookEntity } from '@mathflat/domain/@entities/(Content)/Workbook/dto'
import type { ConceptChipDomain } from '@mathflat/domain/@entities/ConceptChip/domain'
import type { Entity as ConceptChipEntity } from '@mathflat/domain/@entities/ConceptChip/dto'
import type { Entity as OrderEntity } from '@mathflat/domain/@entities/PODMall/Order/dto'
import type { Entity as SignatureProductDetailEntity } from '@mathflat/domain/@entities/PODMall/ProductDetail/dto'

import type { Academy, Scenario, SubScenario, Worksheet } from '@/dto'
import type { convertSignatureWorkbookDataForDataTracking } from '@/page/MakeSignatureWorkbook/Step2_시그니처교재표지편집/_service/SignatureWorkbookCoverEdit.service'
import type { ScenarioService } from '@/service/scenario.service'
import type {
  학습지_기출업로드,
  학습지_단원유형별,
  학습지_수능모의고사,
  학습지_시그니처교재,
  학습지_시중교재,
  학습지_원클릭복습,
} from '@/types/common/dataTracking'
import type worksheetUtil from '@/utils/Worksheet'

/**
 * @deprecated
 * data tracking2로 바뀌면서 API track등 다 정리하고, 이벤트들도 event.schema에 새로 정의
 */
export const _mp_api_events = {
  학습지자동채점제출: { eventCode: 'S00-00', eventName: '학습지자동채점제출' },
  빠른정답진입: { eventCode: 'S00-00', eventName: '빠른정답진입' },
  출제된교재조회시: { eventCode: 'S00-00', eventName: '출제된교재조회시' },
  출제된교재숙제조회: { eventCode: 'S00-00', eventName: '출제된교재숙제조회' },
  학생학습내역주차별문제요약정보조회: {
    eventCode: 'S00-00',
    eventName: '학생학습내역주차별문제요약정보조회',
  },
  학습내역난이도별통계: { eventCode: 'S00-00', eventName: '학습내역난이도별통계' },
  보충학습필요단원조회: { eventCode: 'S00-00', eventName: '보충학습필요단원조회' },
  로그인: { eventCode: 'T10-01', eventName: '로그인' },
  비번재설정1: { eventCode: 'T10-03', eventName: '비번재설정1' },
  비번재설정2: { eventCode: 'T10-04', eventName: '비번재설정2' },
  비번재설정3: { eventCode: 'T10-05', eventName: '비번재설정3' },
  로그아웃: { eventCode: 'T21-01', eventName: '로그아웃' },
  내정보수정: { eventCode: 'T21-02', eventName: '내정보수정' },
  학원정보수정: { eventCode: 'T21-02', eventName: '학원정보수정' },
  프리미엄체험신청: { eventCode: 'T21-02', eventName: '프리미엄체험신청' },
  비번수정: { eventCode: 'T21-03', eventName: '비번수정' },
  로고수정: { eventCode: 'T21-04', eventName: '로고수정' },
  분류수정: { eventCode: 'T21-05', eventName: '분류수정' },
  학원과금정보조회: { eventCode: 'T22-01', eventName: '학원과금정보조회' },
  추가요금조회: { eventCode: 'T22-02', eventName: '추가요금조회' },
  문자과금조회: { eventCode: 'T22-03', eventName: '문자과금조회' },
  b2g계약서_제출: { eventCode: 'T61-01', eventName: 'b2g계약서_제출' },
  b2g계약서_정보조회: { eventCode: 'T61-02', eventName: 'b2g계약서_정보조회' },
  b2g계약서_다운로드: { eventCode: 'T61-03', eventName: 'b2g계약서_다운로드' },
  '개념강의_학년-학기_선택': { eventCode: 'T30-01', eventName: '개념강의_학년-학기_선택' },
  개념강의_학생의_강의시청내역_불러오기: {
    eventCode: 'T30-02',
    eventName: '개념강의_학생의_강의시청내역_불러오기',
  },
  이메일로학습지전송: { eventCode: 'T31-01', eventName: '이메일로학습지전송' },
  내학습지조회: { eventCode: 'T31-01', eventName: '내학습지조회' },
  내신대비교과서학습지조회: { eventCode: 'T31-01', eventName: '내신대비교과서학습지조회' },
  학습지삭제: { eventCode: 'T31-01', eventName: '학습지삭제' },
  학습지상세조회: { eventCode: 'T31-01', eventName: '학습지상세조회' },
  학습지문제조회: { eventCode: 'T31-01', eventName: '학습지문제조회' },
  학습지공개여부수정: { eventCode: 'T31-01', eventName: '학습지공개여부수정' },
  학습지학생앱공개여부수정: { eventCode: 'T31-01', eventName: '학습지학생앱공개여부수정' },
  학습지출제취소: { eventCode: 'T31-01', eventName: '학습지출제취소' },
  학습지출제: { eventCode: 'T31-02', eventName: '학습지출제' },
  학습지다운로드: { eventCode: 'T31-03', eventName: '학습지다운로드' },
  이메일로전송_학생조회: { eventCode: 'T31-09', eventName: '이메일로전송_학생조회' },
  즐겨찾는문제조회: { eventCode: 'T31-11', eventName: '즐겨찾는문제조회' },
  즐겨찾는문제교육과정트리조회: { eventCode: 'T31-11', eventName: '즐겨찾는문제교육과정트리조회' },
  여러즐겨찾는문제조회: { eventCode: 'T31-11', eventName: '여러즐겨찾는문제조회' },
  즐겨찾는문제해제: { eventCode: 'T31-11', eventName: '즐겨찾는문제해제' },
  교재디자인템플릿조회: { eventCode: 'T32-01', eventName: '교재디자인템플릿조회' },
  교재조회: { eventCode: 'T32-01', eventName: '교재조회' },
  교재삭제: { eventCode: 'T32-01', eventName: '교재삭제' },
  교재다운로드: { eventCode: 'T32-01', eventName: '교재다운로드' },
  교재수정: { eventCode: 'T32-02', eventName: '교재수정' },
  연산학습지조회_구: { eventCode: 'T32-12', eventName: '연산학습지조회_구' },
  연산학습지조회: { eventCode: 'T32-12', eventName: '연산학습지조회' },
  학력평가_원본시험지조회: { eventCode: 'T32-12', eventName: '학력평가_원본시험지조회' },
  학력평가_시험지조회: { eventCode: 'T32-12', eventName: '학력평가_시험지조회' },
  학력평가_시험지출제: { eventCode: 'T32-12', eventName: '학력평가_시험지출제' },
  학력평가_시험지출제취소: { eventCode: 'T32-12', eventName: '학력평가_시험지출제취소' },
  학력평가_시험지채점조회: { eventCode: 'T32-12', eventName: '학력평가_시험지채점조회' },
  학력평가_시험지채점문제조회: { eventCode: 'T32-12', eventName: '학력평가_시험지채점문제조회' },
  학력평가_시험지채점: { eventCode: 'T32-12', eventName: '학력평가_시험지채점' },
  학력평가_인증서다운로드: { eventCode: 'T32-12', eventName: '학력평가_인증서다운로드' },
  시그니처교재주문_페이지샵장바구니이동: {
    eventCode: 'T32-13',
    eventName: '시그니처교재주문_페이지샵장바구니이동',
  },
  시그니처교재_페이지샵마이페이지이동: {
    eventCode: 'T32-13',
    eventName: '시그니처교재_페이지샵마이페이지이동',
  },
  시그니처교재_페이지샵미리보기: {
    eventCode: 'T32-15',
    eventName: '시그니처교재_페이지샵미리보기',
  },

  내신대비추천학습지조회: { eventCode: 'T33-15', eventName: '내신대비추천학습지조회' },
  수능모의고사학습지조회: { eventCode: 'T33-29', eventName: '수능모의고사학습지조회' },

  /*
   * 연산
   * */
  연산_학습지조회: { eventCode: 'T33-43', eventName: '연산_학습지조회' },
  '연산_학습지인쇄/다운로드': { eventCode: 'T33-43', eventName: '연산_학습지인쇄/다운로드' },
  '연산_초등1~2_문제보기': { eventCode: 'T33-43', eventName: '연산_초등1~2_문제보기' },
  '연산_초등1~2_정답보기': { eventCode: 'T33-43', eventName: '연산_초등1~2_정답보기' },
  '연산_초등3~6_문제보기': { eventCode: 'T33-43', eventName: '연산_초등3~6_문제보기' },
  '연산_초등3~6_정답보기': { eventCode: 'T33-43', eventName: '연산_초등3~6_정답보기' },
  연산_중고등_미리보기: { eventCode: 'T33-43', eventName: '연산_중고등_미리보기' },
  연산_중고등_수정: { eventCode: 'T33-43', eventName: '연산_중고등_수정' },
  연산_중고등_출제: { eventCode: 'T33-43', eventName: '연산_중고등_출제' },
  연산_미리보기좌: { eventCode: 'T33-43', eventName: '연산_미리보기좌' },
  연산_미리보기우: { eventCode: 'T33-43', eventName: '연산_미리보기우' },

  입학TEST학습지조회: { eventCode: 'T33-49', eventName: '입학TEST학습지조회' },
  주간TEST학습지조회: { eventCode: 'T33-63', eventName: '주간TEST학습지조회' },
  주간TEST학습지일정표조회: { eventCode: 'T33-63', eventName: '주간TEST학습지일정표조회' },
  단원TEST학습지조회: { eventCode: 'T33-78', eventName: '단원TEST학습지조회' },
  '수능특강/완성_목록_조회': { eventCode: 'T33-120', eventName: ' 수능특강/완성_목록_조회' },
  다른기관학습지조회: { eventCode: 'T34-01', eventName: '다른기관학습지조회' },
  학습지교재만들기_새문제추가_단원트리: {
    eventCode: 'T35-01',
    eventName: '학습지교재만들기_새문제추가_단원트리',
  },
  학습지만들기1단계_난이도설정수정: {
    eventCode: 'T35-02',
    eventName: '학습지만들기1단계_난이도설정수정',
  },
  '학습지만들기1단계_수능/모의고사_필터선택완료시조회': {
    eventCode: 'T35-04',
    eventName: '학습지만들기1단계_수능/모의고사_필터선택완료시조회',
  },
  학습지만들기2단계_유형별개념조회: {
    eventCode: 'T35-11',
    eventName: '학습지만들기2단계_유형별개념조회',
  },
  학습지만들기2단계_소단원별개념조회: {
    eventCode: 'T35-11',
    eventName: '학습지만들기2단계_소단원별개념조회',
  },
  교재필터상세조회: { eventCode: 'T36-01', eventName: '교재필터상세조회' },
  교재만들기2단계_문제조회: { eventCode: 'T36-06', eventName: '교재만들기2단계_문제조회' },
  교재생성2단계새_문제추가: { eventCode: 'T36-06', eventName: '교재생성2단계새_문제추가' },
  교재만들기3단계_학년정보추출: { eventCode: 'T36-09', eventName: '교재만들기3단계_학년정보추출' },
  교재만들기3단계: { eventCode: 'T36-09', eventName: '교재만들기3단계' },
  교재수정시조회: { eventCode: 'T37-01', eventName: '교재수정시조회' },
  '학습내역지난_학습조회(단일학생)': {
    eventCode: 'T41-01',
    eventName: '학습내역지난_학습조회(단일학생)',
  },
  학습지교재_숙제학습내역조회: { eventCode: 'T41-01', eventName: '학습지교재_숙제학습내역조회' },
  특정학생_학습지교재_학습내역조회: {
    eventCode: 'T41-01',
    eventName: '특정학생_학습지교재_학습내역조회',
  },
  학년별숙제조회: { eventCode: 'T41-01', eventName: '학년별숙제조회' },
  반별숙제조회: { eventCode: 'T41-01', eventName: '반별숙제조회' },
  반별숙제진도가있는날조회: { eventCode: 'T41-01', eventName: '반별숙제진도가있는날조회' },
  학년별숙제진도가있는날조회: { eventCode: 'T41-01', eventName: '학년별숙제진도가있는날조회' },
  숙제조회: { eventCode: 'T41-02', eventName: '숙제조회' },
  숙제상태수정: { eventCode: 'T41-02', eventName: '숙제상태수정' },
  숙제출제해제: { eventCode: 'T41-02', eventName: '숙제출제해제' },
  특정학년특정일기준_기간내학습일조회: {
    eventCode: 'T41-02',
    eventName: '특정학년특정일기준_기간내학습일조회',
  },
  특정반특정일기준_기간내학습일조회: {
    eventCode: 'T41-02',
    eventName: '특정반특정일기준_기간내학습일조회',
  },
  학년별_학습지교재_학습내역조회: {
    eventCode: 'T41-02',
    eventName: '학년별_학습지교재_학습내역조회',
  },
  반별_학습지교재_학습내역조회: { eventCode: 'T41-02', eventName: '반별_학습지교재_학습내역조회' },
  특정학생숙제조회: { eventCode: 'T41-02', eventName: '특정학생숙제조회' },
  숙제상세조회: { eventCode: 'T41-02', eventName: '숙제상세조회' },
  특정학생의숙제진도가있는날조회: {
    eventCode: 'T41-02',
    eventName: '특정학생의숙제진도가있는날조회',
  },
  학습지출제일채점일수정: { eventCode: 'T42-01', eventName: '학습지출제일채점일수정' },
  학년별출제된학습지조회: { eventCode: 'T42-01', eventName: '학년별출제된학습지조회' },
  반별출제된학습지조회: { eventCode: 'T42-01', eventName: '반별출제된학습지조회' },
  학년별출제된학습지채점조회: { eventCode: 'T42-02', eventName: '학년별출제된학습지채점조회' },
  반별출제된학습지채점조회: { eventCode: 'T42-02', eventName: '반별출제된학습지채점조회' },
  특정학생학습지조회: { eventCode: 'T42-05', eventName: '특정학생학습지조회' },
  출제된학습지숙제조회: { eventCode: 'T42-05', eventName: '출제된학습지숙제조회' },
  출제된학습지상세조회: { eventCode: 'T42-06', eventName: '출제된학습지상세조회' },
  출제된학습지문제조회: { eventCode: 'T42-06', eventName: '출제된학습지문제조회' },
  학습지문제당채점: { eventCode: 'T42-06', eventName: '학습지문제당채점' },
  학습지교재상세조회: { eventCode: 'T42-06', eventName: '학습지교재상세조회' },
  단원별취약유형관리_단원트리: { eventCode: 'T42-07', eventName: '단원별취약유형관리_단원트리' },
  단원별취약유형학습지문제조회: { eventCode: 'T42-07', eventName: '단원별취약유형학습지문제조회' },
  '특정학생유형/단원분석조회': { eventCode: 'T42-07', eventName: '특정학생유형/단원분석조회' },
  '단원별취약유형진입(최근채점된교육과정_자동로드)': {
    eventCode: 'T42-07',
    eventName: '단원별취약유형진입(최근채점된교육과정_자동로드)',
  },
  기간별오답학습지문제조회: { eventCode: 'T42-08', eventName: '기간별오답학습지문제조회' },
  학습지오답학습지문제조회: { eventCode: 'T42-09', eventName: '학습지오답학습지문제조회' },
  숙제출제: { eventCode: 'T42-12', eventName: '숙제출제' },
  학년별출제된교재조회: { eventCode: 'T43-01', eventName: '학년별출제된교재조회' },
  학년별출제된교재진도조회: { eventCode: 'T43-01', eventName: '학년별출제된교재진도조회' },
  학년별출제된교재채점조회: { eventCode: 'T43-01', eventName: '학년별출제된교재채점조회' },
  반별출제된교재조회: { eventCode: 'T43-01', eventName: '반별출제된교재조회' },
  반별출제된교재진도조회: { eventCode: 'T43-01', eventName: '반별출제된교재진도조회' },
  반별출제된교재채점조회: { eventCode: 'T43-01', eventName: '반별출제된교재채점조회' },
  교재페이지조회: { eventCode: 'T43-05', eventName: '교재페이지조회' },
  교재페이지문제조회: { eventCode: 'T43-05', eventName: '교재페이지문제조회' },
  특정학생출제된교재조회: { eventCode: 'T43-05', eventName: '특정학생출제된교재조회' },
  특정학생출제된교재진도조회: { eventCode: 'T43-05', eventName: '특정학생출제된교재진도조회' },
  특정학생출제된교재채점조회: { eventCode: 'T43-05', eventName: '특정학생출제된교재채점조회' },
  교재출제재출제: { eventCode: 'T43-05', eventName: '교재출제재출제' },
  교재출제취소: { eventCode: 'T43-05', eventName: '교재출제취소' },
  특정교재_회차출제취소: { eventCode: 'T43-05', eventName: '특정교재_회차출제취소' },
  특정교재_진도상태수정: { eventCode: 'T43-05', eventName: '특정교재_진도상태수정' },
  교재문제채점: { eventCode: 'T43-05', eventName: '교재문제채점' },
  교재페이지별오답학습지문제조회: {
    eventCode: 'T43-07',
    eventName: '교재페이지별오답학습지문제조회',
  },
  '교재문제_쌍둥이유사검색&문제별오답학습지_문제 조회': {
    eventCode: 'T43-08',
    eventName: '교재문제_쌍둥이유사검색&문제별오답학습지_문제 조회',
  },
  수업보고서중복체크: { eventCode: 'T44-01', eventName: '수업보고서중복체크' },
  학년별그룹수업보고서목록조회: { eventCode: 'T44-02', eventName: '학년별그룹수업보고서목록조회' },
  반별그룹수업보고서목록조회: { eventCode: 'T44-02', eventName: '반별그룹수업보고서목록조회' },
  수업보고서목록조회: { eventCode: 'T44-03', eventName: '수업보고서목록조회' },
  수업보고서생성가능학생조회: { eventCode: 'T44-05', eventName: '수업보고서생성가능학생조회' },
  그룹수업보고서생성: { eventCode: 'T44-06', eventName: '그룹수업보고서생성' },
  수업보고서생성: { eventCode: 'T44-07', eventName: '수업보고서생성' },
  수업보고서수정: { eventCode: 'T44-08', eventName: '수업보고서수정' },
  수업보고서조회: { eventCode: 'T44-08', eventName: '수업보고서조회' },
  '수업보고서조회(내부)': { eventCode: 'T44-08', eventName: '수업보고서조회(내부)' },
  월별수업보고서생성시생성가능한월조회: {
    eventCode: 'T44-08',
    eventName: '월별수업보고서생성시생성가능한월조회',
  },
  학부모앱수업보고서공개여부수정: {
    eventCode: 'T44-08',
    eventName: '학부모앱수업보고서공개여부수정',
  },
  수업보고서다운로드: { eventCode: 'T44-09', eventName: '수업보고서다운로드' },
  수업보고서삭제: { eventCode: 'T44-12', eventName: '수업보고서삭제' },
  수업보고서일괄삭제: { eventCode: 'T44-13', eventName: '수업보고서일괄삭제' },
  최근생성된수업보고서_년월조회: {
    eventCode: 'T44-14',
    eventName: '최근생성된수업보고서_년월조회',
  },
  보고서목록_학부모앱_공개전환: { eventCode: 'T44-15', eventName: '보고서목록_학부모앱_공개전환' },
  보고서목록_학부모앱_비공개전환: {
    eventCode: 'T44-16',
    eventName: '보고서목록_학부모앱_비공개전환',
  },
  보고서목록_학부모앱_일괄공개전환: {
    eventCode: 'T44-17',
    eventName: '보고서목록_학부모앱_일괄공개전환',
  },
  보고서목록_학부모앱_일괄비공개전환: {
    eventCode: 'T44-18',
    eventName: '보고서목록_학부모앱_일괄비공개전환',
  },
  보고서ID기반_보고서정보조회: {
    eventCode: 'T44-19',
    eventName: '보고서ID기반_보고서정보조회',
  },
  보고서ID기반_일괄보고서정보조회: {
    eventCode: 'T44-20',
    eventName: '보고서ID기반_일괄보고서정보조회',
  },
  학생입실등록: { eventCode: 'T45-04', eventName: '학생입실등록' },
  학생퇴실등록: { eventCode: 'T45-05', eventName: '학생퇴실등록' },
  유형분석_유형칩_조회: { eventCode: 'T46-01', eventName: '유형분석_유형칩_조회' },
  유형분석_학생성취도_조회: { eventCode: 'T46-01', eventName: '유형분석_학생성취도_조회' },
  유형분석_학생성취도_과거이력_조회: {
    eventCode: 'T46-01',
    eventName: '유형분석_학생성취도_과거이력_조회',
  },
  유형분석_유형칩별_상세보기: { eventCode: 'T46-01', eventName: '유형분석_유형칩별_상세보기' },
  유형분석_학습지만들기: { eventCode: 'T46-03', eventName: '유형분석_학습지만들기' },
  유형분석_보고서_조회: { eventCode: 'T46-01', eventName: '유형분석_보고서_조회' },
  유형분석_보고서_삭제: { eventCode: 'T46-01', eventName: '유형분석_보고서_삭제' },

  학생조회: { eventCode: 'T51-01', eventName: '학생조회' },
  여러학생삭제: { eventCode: 'T51-01', eventName: '여러학생삭제' },
  학생전체삭제: { eventCode: 'T51-01', eventName: '학생전체삭제' },
  여러학생수정: { eventCode: 'T51-01', eventName: '여러학생수정' },
  학생일괄등록: { eventCode: 'T51-02', eventName: '학생일괄등록' },
  학생일괄등록양식다운로드: { eventCode: 'T51-02', eventName: '학생일괄등록양식다운로드' },
  학생등록: { eventCode: 'T51-03', eventName: '학생등록' },
  학부모등록: { eventCode: 'T51-03', eventName: '학부모등록' },
  학생학부모비번수정: { eventCode: 'T51-04', eventName: '학생학부모비번수정' },
  학생학부모_로그인안내문자전송: {
    eventCode: 'T51-04',
    eventName: '학생학부모_로그인안내문자전송',
  },
  학생출결번호재발급: { eventCode: 'T51-04', eventName: '학생출결번호재발급' },
  특정학생조회: { eventCode: 'T51-04', eventName: '특정학생조회' },
  특정학생수정: { eventCode: 'T51-04', eventName: '특정학생수정' },
  학생출결번호수정: { eventCode: 'T51-04', eventName: '학생출결번호수정' },
  특정학부모조회: { eventCode: 'T51-04', eventName: '특정학부모조회' },
  특정학부모수정: { eventCode: 'T51-04', eventName: '특정학부모수정' },
  형제연결: { eventCode: 'T51-05', eventName: '형제연결' },
  형제연결해제: { eventCode: 'T51-05', eventName: '형제연결해제' },
  반조회: { eventCode: 'T51-07', eventName: '반조회' },
  반순서수정: { eventCode: 'T51-07', eventName: '반순서수정' },
  반삭제: { eventCode: 'T51-07', eventName: '반삭제' },
  반관리_선생님필터목록조회: { eventCode: 'T51-07', eventName: '반관리_선생님필터목록조회' },
  반생성: { eventCode: 'T51-08', eventName: '반생성' },
  반정보수정: { eventCode: 'T51-09', eventName: '반정보수정' },
  특정반정보조회: { eventCode: 'T51-09', eventName: '특정반정보조회' },
  특정반조회: { eventCode: 'T51-09', eventName: '특정반조회' },
  선생님조회: { eventCode: 'T51-10', eventName: '선생님조회' },
  여러선생님삭제: { eventCode: 'T51-10', eventName: '여러선생님삭제' },
  선생님등록: { eventCode: 'T51-11', eventName: '선생님등록' },
  특정선생님조회: { eventCode: 'T51-12', eventName: '특정선생님조회' },
  특정선생님수정: { eventCode: 'T51-12', eventName: '특정선생님수정' },
  학원공지사항조회: { eventCode: 'T51-13', eventName: '학원공지사항조회' },
  학부모앱공지사항삭제: { eventCode: 'T51-13', eventName: '학부모앱공지사항삭제' },
  학부모앱공지사항조회: { eventCode: 'T51-13', eventName: '학부모앱공지사항조회' },
  학부모앱공지사항등록: { eventCode: 'T51-14', eventName: '학부모앱공지사항등록' },
  특정학원공지사항조회: { eventCode: 'T51-15', eventName: '특정학원공지사항조회' },
  특정학부모앱공지사항수정: { eventCode: 'T51-15', eventName: '특정학부모앱공지사항수정' },
  특정학부모앱공지사항조회: { eventCode: 'T51-15', eventName: '특정학부모앱공지사항조회' },
  학생앱설정조회: { eventCode: 'T51-16', eventName: '학생앱설정조회' },
  특정학생앱설정조회: { eventCode: 'T51-16', eventName: '특정학생앱설정조회' },
  학생앱설정수정: { eventCode: 'T51-16', eventName: '학생앱설정수정' },
  REDIS_KEY조회: { eventCode: 'T51-17', eventName: 'REDIS_KEY조회' },
  문자발송될샘플조회: { eventCode: 'T52-01', eventName: '문자발송될샘플조회' },
  문자템플릿기반문자발송: { eventCode: 'T52-01', eventName: '문자템플릿기반문자발송' },
  문자전송_반별보기_학생번호조회: {
    eventCode: 'T52-02',
    eventName: '문자전송_반별보기_학생번호조회',
  },
  문자템플릿조회: { eventCode: 'T52-03', eventName: '문자템플릿조회' },
  문자템플릿수정: { eventCode: 'T52-03', eventName: '문자템플릿수정' },
  문자템플릿삭제: { eventCode: 'T52-03', eventName: '문자템플릿삭제' },
  문자템플릿등록: { eventCode: 'T52-04', eventName: '문자템플릿등록' },
  문자발송결과조회: { eventCode: 'T52-05', eventName: '문자발송결과조회' },
  SMS핸드폰인증: { eventCode: 'T52-06', eventName: 'SMS핸드폰인증' },
  NICE인증발신번호등록: { eventCode: 'T52-06', eventName: 'NICE인증발신번호등록' },
  학원메타데이터수정: {
    eventCode: 'T52-07',
    eventName: '학원메타데이터수정',
  },
  출결관리_반별보기_특정학생출결정보조회: {
    eventCode: 'T53-04',
    eventName: '출결관리_반별보기_특정학생출결정보조회',
  },
  출결조회: { eventCode: 'T53-04', eventName: '출결조회' },
  출결삭제: { eventCode: 'T53-04', eventName: '출결삭제' },
  출결다운로드: { eventCode: 'T53-06', eventName: '출결다운로드' },
  교육비조회: { eventCode: 'T53-07', eventName: '교육비조회' },
  교육비삭제: { eventCode: 'T53-08', eventName: '교육비삭제' },
  교육비수정: { eventCode: 'T53-08', eventName: '교육비수정' },
  교육비등록: { eventCode: 'T53-08', eventName: '교육비등록' },
  교육비다운로드: { eventCode: 'T53-09', eventName: '교육비다운로드' },
  자주묻는질문조회: { eventCode: 'T54-03', eventName: '자주묻는질문조회' },
  '1:1문의삭제': { eventCode: 'T54-04', eventName: '1:1문의삭제' },
  '1:1문의조회': { eventCode: 'T54-04', eventName: '1:1문의조회' },
  '특정1:1문의조회': { eventCode: 'T54-04', eventName: '특정1:1문의조회' },
  '1:1문의등록': { eventCode: 'T54-05', eventName: '1:1문의등록' },
  이벤트조회: { eventCode: 'T55-01', eventName: '이벤트조회' },
  이벤트배너조회: { eventCode: 'T55-02', eventName: '이벤트배너조회' },
  특정이벤트조회: { eventCode: 'T55-02', eventName: '특정이벤트조회' },
  세션유효성검사: { eventCode: 'T81-01', eventName: '세션유효성검사' },
  프린터초기화메타데이터추가: { eventCode: 'T81-01', eventName: '프린터초기화메타데이터추가' },
  학원정보가져오기: { eventCode: 'T81-02', eventName: '학원정보가져오기' },
  여러학생조회: { eventCode: 'T99-00', eventName: '여러학생조회' },
  출결관리_학년별보기_특정학생출결정보조회: {
    eventCode: 'T99-00',
    eventName: '출결관리_학년별보기_특정학생출결정보조회',
  },
  특정교육과정과하위교육과정조회: {
    eventCode: 'T99-00',
    eventName: '특정교육과정과하위교육과정조회',
  },
  여러문제조회: { eventCode: 'T99-00', eventName: '여러문제조회' },
  문자발송: { eventCode: 'T99-00', eventName: '문자발송' },
  팝업조회: { eventCode: 'T99-00', eventName: '팝업조회' },
  '페르마학원D-code조회': { eventCode: 'T99-00', eventName: '페르마학원D-code조회' },
  FCM토큰저장: { eventCode: 'T99-00', eventName: 'FCM토큰저장' },
  페르마교재식별자조회: { eventCode: 'T99-00', eventName: '페르마교재식별자조회' },
  특정학생분석조회: { eventCode: 'T99-00', eventName: '특정학생분석조회' },
  특정학습지의난이도별통계조회: { eventCode: 'T99-00', eventName: '특정학습지의난이도별통계조회' },
  '학습지만들기1단계_난이도설정(무조건발생)': {
    eventCode: 'T99-01',
    eventName: '학습지만들기1단계_난이도설정(무조건발생)',
  },
  여러학부모삭제: { eventCode: 'T99-01', eventName: '여러학부모삭제' },
  학습지만들기1단계_범위조회필터: {
    eventCode: 'T99-01',
    eventName: '학습지만들기1단계_범위조회필터',
  },
  '교재생성&수정': { eventCode: 'T99-01', eventName: '교재생성&수정' },
  서술형정답이미지등록: { eventCode: 'T99-01', eventName: '서술형정답이미지등록' },
  즐겨찾는문제등록: { eventCode: 'T99-02', eventName: '즐겨찾는문제등록' },
  문제신고: { eventCode: 'T99-02', eventName: '문제신고' },
  시중문제신고: { eventCode: 'T99-02', eventName: '시중문제신고' },
  유형신고: { eventCode: 'T99-02', eventName: '유형신고' },
  학습지신고: { eventCode: 'T99-02', eventName: '학습지신고' },
  학습지만들기2_쌍둥이유사조회: { eventCode: 'T35-09', eventName: '학습지만들기2_쌍둥이유사조회' },
  일반팝업: { eventCode: 'T99-01', eventName: '일반팝업' },
  서버점검조회: { eventCode: 'T99-01', eventName: '서버점검조회' },
  이달의업데이트팝업: { eventCode: 'T99-01', eventName: '이달의업데이트팝업' },
  공지사항: { eventCode: 'T99-01', eventName: '공지사항' },
  원클릭보고서_생성버튼선택: { eventCode: 'T42-10', eventName: '원클릭보고서_생성버튼선택' },
  그룹원클릭보고서_생성선택: { eventCode: 'T42-03', eventName: '그룹원클릭보고서_생성선택' },
  보고서_생성버튼선택: { eventCode: 'T44-02', eventName: '보고서_생성버튼선택' },
  그룹원클릭보고서_다운로드: { eventCode: 'T61-01', eventName: '그룹원클릭보고서_다운로드' },
  PC버전등록_인쇄: { eventCode: 'T99-03', eventName: 'PC버전등록_인쇄' },
  학습지_인쇄: { eventCode: 'T99-03', eventName: '학습지_인쇄' },
  '학습지_인쇄(비동기)': { eventCode: 'T99-03', eventName: '학습지_인쇄(비동기)' },
  인쇄_미상_미사용: { eventCode: 'T99-00', eventName: '인쇄_미상_미사용' },
  연산_인쇄: { eventCode: 'T99-03', eventName: '연산_인쇄' },
  '연산_인쇄(비동기)': { eventCode: 'T99-03', eventName: '연산_인쇄(비동기)' },
  학원교재_인쇄: { eventCode: 'T99-03', eventName: '학원교재_인쇄' },
  '학원교재_인쇄(비동기)': { eventCode: 'T99-03', eventName: '학원교재_인쇄(비동기)' },
  교재빠른정답: { eventCode: 'T99-00', eventName: '교재빠른정답' },
  보고서_인쇄: { eventCode: 'T99-03', eventName: '보고서_인쇄' },
  '원클릭보고서_인쇄(비동기)': { eventCode: 'T99-03', eventName: '원클릭보고서_인쇄(비동기)' },
  수업_그룹교재정보조회: { eventCode: 'T43-01', eventName: '수업_그룹교재정보조회' },
  수업_그룹교재진도조회: { eventCode: 'T43-01', eventName: '수업_그룹교재진도조회' },
  수업_그룹교재채점조회: { eventCode: 'T43-01', eventName: '수업_그룹교재채점조회' },
  학습지디자인템플릿조회: {
    eventCode: 'T35-00',
    eventName: '학습지디자인템플릿조회',
  },
  '학습지만들기1_단원유형별(필터생성변경시마다)': {
    eventCode: 'T35-01',
    eventName: '학습지만들기1_단원유형별(필터생성변경시마다)',
  },
  '학습지만들기1_단원/유형별_학습지필터생성': {
    eventCode: 'T35-01',
    eventName: '학습지만들기1_단원/유형별_학습지필터생성',
  },
  학습지만들기1_시중교재_학습지필터옵션생성: {
    eventCode: 'T35-03',
    eventName: '학습지만들기1_시중교재_학습지필터옵션생성',
  },
  학습지만들기1_모의고사_필터생성변경시마다: {
    eventCode: 'T35-04',
    eventName: '학습지만들기1_모의고사_필터생성변경시마다',
  },
  학습지만들기1_기출업로드_기타학습지_필터생성: {
    eventCode: 'T35-05',
    eventName: '학습지만들기1_기출업로드_기타학습지_필터생성',
  },
  학습지만들기1_기출업로드_기출시험지_필터생성: {
    eventCode: 'T35-06',
    eventName: '학습지만들기1_기출업로드_기출시험지_필터생성',
  },
  학습지만들기1_학습지문제수조회: {
    eventCode: 'T35-01',
    eventName: '학습지만들기1_학습지문제수조회',
  },
  단원기간별_단원별_필터생성변경시마다: {
    eventCode: 'T42-07',
    eventName: '단원기간별_단원별_필터생성변경시마다',
  },
  단원기간별_기간별_필터생성변경시마다: {
    eventCode: 'T42-08',
    eventName: '단원기간별_기간별_필터생성변경시마다',
  },
  개별오답학습지필터_필터생성변경시마다: {
    eventCode: 'T42-11',
    eventName: '개별오답학습지필터_필터생성변경시마다',
  },
  '학습지만들기1_학습지문제조회(옵션변경마다)': {
    eventCode: 'T35-01',
    eventName: '학습지만들기1_학습지문제조회(옵션변경마다)',
  },
  학습지만들기3_학습지만들기버튼선택시: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지만들기버튼선택시',
  },
  학습지만들기3_학습지수정하기선택시: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지수정하기선택시',
  },
  학습지만들기3_출제된학습지수정하기선택시: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_출제된학습지수정하기선택시',
  },
  학습지만들기3_학습지디자인템플릿조회: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지디자인템플릿조회',
  },
  학습지만들기3_특정학습지디자인템플릿조회: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_특정학습지디자인템플릿조회',
  },
  학습지만들기3_학습지템플릿생성: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지템플릿생성',
  },
  학습지만들기3_학습지템플릿수정: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지템플릿수정',
  },
  학습지만들기3_학습지템플릿삭제: {
    eventCode: 'T35-12',
    eventName: '학습지만들기3_학습지템플릿삭제',
  },
  // 기출업로드
  기출업로드_원본조회: {
    eventCode: 'T99_01',
    eventName: '기출업로드_원본조회',
  },
  기출업로드_기타학습지_원본생성: {
    eventCode: 'T99_01',
    eventName: '기출업로드_기타학습지_원본생성',
  },
  기출업로드_기출시험지_원본생성: {
    eventCode: 'T99_01',
    eventName: '기출업로드_기출시험지_원본생성',
  },
  기출업로드_원본삭제: {
    eventCode: 'T99_01',
    eventName: '기출업로드_원본삭제',
  },

  // 원클릭
  학습지만들기_원클릭복습학습지_문제조회: {
    eventCode: 'T99-01',
    eventName: '학습지만들기_원클릭복습학습지_문제조회',
  },
  학습지만들기_원클릭복습학습지_필터생성변경시마다: {
    eventCode: 'T99-01',
    eventName: '학습지만들기_원클릭복습학습지_필터생성변경시마다',
  },

  // 후기

  후기목록조회: {
    eventCode: 'T55-01',
    eventName: '후기목록조회',
  },
  가상학생등록: { eventCode: 'T71-00', eventName: '가상학생등록' },
  시나리오_유저_조회: {
    eventCode: 'T99-03',
    eventName: '시나리오_유저_조회',
  },
  시나리오_유저_수행: {
    eventCode: 'T99-03',
    eventName: '시나리오_유저_수행',
    eventProps: {
      unitId: undefined as unknown as Scenario['id'] | SubScenario['id'],
    },
  },
  시나리오_유저_수행취소: {
    eventCode: 'T99-03',
    eventName: '시나리오_유저_수행취소',
    eventProps: {
      unitId: undefined as unknown as Scenario['id'] | SubScenario['id'],
    },
  },
  시나리오_마지막_출제학생: {
    eventCode: 'T99-03',
    eventName: '시나리오_마지막_출제학생',
  },
  시나리오_마지막_채점학생: {
    eventCode: 'T99-03',
    eventName: '시나리오_마지막_채점학생',
  },
  학습통계_학년별_조회: {
    eventCode: 'S00-00',
    eventName: '학습통계_학년별_조회',
  },

  학습통계_반별_조회: {
    eventCode: 'S00-00',
    eventName: '학습통계_반별_조회',
  },

  마이리스트_조회: {
    eventCode: 'T99-01',
    eventName: '마이리스트_조회',
  },
  마이리스트_생성: {
    eventCode: 'T99-01',
    eventName: '마이리스트_생성',
  },
  마이리스트_수정: {
    eventCode: 'T99-01',
    eventName: '마이리스트_수정',
  },
  마이리스트_삭제: {
    eventCode: 'T99-01',
    eventName: '마이리스트_삭제',
  },
  마이리스트_학습지_담기: {
    eventCode: 'T99-01',
    eventName: '마이리스트_학습지_담기',
  },
  마이리스트_학습지_삭제: {
    eventCode: 'T99-01',
    eventName: '마이리스트_학습지_삭제',
  },
}

/**
 * @deprecated
 * data tracking2로 바뀌면서 API track등 다 정리하고, 이벤트들도 event.schema에 새로 정의
 */
export const _mp_events = {
  무료체험신청_말풍선_이동클릭: {
    eventCode: 'T10-01',
    eventName: '무료체험신청_말풍선_이동클릭',
    eventProps: {},
  },
  무료체험신청_말풍선_X클릭: {
    eventCode: 'T10-01',
    eventName: '무료체험신청_말풍선_X클릭',
  },
  로그인화면_수동: {
    eventCode: 'T10-01',
    eventName: '로그인화면_수동',
  },
  배송지_수정하기btn: { eventCode: 'T11-01', eventName: '배송지_수정하기btn' },
  배송지_수정완료하기btn: {
    eventCode: 'T11-02',
    eventName: '배송지_수정완료하기btn',
  },
  콘텐츠업데이트PV: {
    eventCode: 'T12-01',
    eventName: '콘텐츠업데이트PV',
  },
  콘텐츠업데이트스크롤: {
    eventCode: 'T12-02',
    eventName: '콘텐츠업데이트스크롤',
    eventProps: {} as {
      height: number
    },
  },

  내정보_교재구매상세_장바구니담기btn: {
    eventCode: 'T23-01',
    eventName: '내정보_교재구매상세_장바구니담기btn',
    eventProps: {} as {
      '교재 ID': string
      '교재 이름': string
      '교재 종류': string
      '교재 학교급': string
      '교재 학년': string
      '교재 학기': string | number | null
    },
  },
  내정보_교재구매상세_재주문하기btn: {
    eventCode: 'T23-01',
    eventName: '내정보_교재구매상세_재주문하기btn',
    eventProps: {} as Partial<OrderEntity.PrintDocumentOrderItem>,
  },
  내정보_교재구매내역상세_송장번호btn: {
    eventCode: 'T23-02',
    eventName: '내정보_교재구매내역상세_송장번호btn',
  },
  개념강의_선생님앱_시청기록_UI: {
    eventCode: '개념강의_선생님앱_시청기록_UI',
    eventName: 'T30-01',
  },
  개념강의_선생님앱_강의_선택: {
    eventCode: 'T30-01',
    eventName: '개념강의_선생님앱_강의_선택',
    eventProps: {} as {
      '학제/학년'?: string
      단원정보_대?: string
      단원정보_중?: string
      강의명?: string
      '재생 여부': boolean
    },
  },
  개념강의_선생님앱_공개설정: {
    eventCode: 'T30-01',
    eventName: '개념강의_선생님앱_공개설정',
    eventProps: {} as {
      토글: boolean
    },
  },
  개념강의_선생님앱_링크공유: {
    eventCode: 'T30-01',
    eventName: '개념강의_선생님앱_링크공유',
    eventProps: {} as {
      '학제/학년'?: string
      단원정보_대?: string
      단원정보_중?: string
      강의명?: string
    },
  },
  개념강의_선생님앱_링크복사: {
    eventCode: 'T30-01',
    eventName: '개념강의_선생님앱_링크복사',
    eventProps: {} as {
      '학제/학년'?: string
      단원정보_대?: string
      단원정보_중?: string
      강의명?: string
    },
  },
  시그니처교재_편집주문하러가기: {
    eventCode: 'T32-15',
    eventName: '시그니처교재_편집주문하러가기',
    eventProps: {} as {
      원본교재명_리스트: string[]
      교재라인_리스트: string[]
    },
  },

  교재장바구니_교재삭제btn: {
    eventCode: 'T32-24',
    eventName: '교재장바구니_교재삭제btn',
    eventProps: {} as {
      '교재 ID': string
      '교재 이름': string
      '교재 종류': string
      '교재 학교급': string
      '교재 학년': string
      '교재 학기': string | number | null
      '주문 수량': number
    },
  },
  교재장바구니_시그니처교재_둘러보기: {
    eventCode: 'T32-24',
    eventName: '교재장바구니_시그니처교재_둘러보기',
  },
  교재장바구니_내교재_둘러보기: {
    eventCode: 'T32-24',
    eventName: '교재장바구니_내교재_둘러보기',
  },
  교재장바구니_결제하기: {
    eventCode: 'T32-24',
    eventName: '교재장바구니_결제하기',
    eventProps: {} as {
      쿠폰보유: boolean
    },
  },
  교재장바구니_PV: {
    eventCode: 'T32-24',
    eventName: '교재장바구니_PV',
    eventProps: {} as {
      쿠폰보유: boolean
    },
  },
  '교재주문/결제_PV': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_PV',
    eventProps: {} as {
      쿠폰보유: boolean
    },
  },
  '교재주문/결제_결제하기btn_n': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_결제하기btn_n',
    eventProps: {} as {
      쿠폰적용: boolean
      쿠폰할인금액: number
      쿠폰이름: string
      쿠폰ID: number | null
    },
  },
  '교재주문/결제_쿠폰박스btn': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_쿠폰박스btn',
  },
  '교재주문/결제_쿠폰사용하기btn': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_쿠폰사용하기btn',
    eventProps: {} as {
      쿠폰혜택: string
      쿠폰혜택값: number
      쿠폰이름: string
      쿠폰ID: number
    },
  },
  '교재주문/결제_쿠폰검색btn': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_쿠폰검색btn',
  },
  '교재주문/결제_쿠폰검색결과': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_쿠폰검색결과',
    eventProps: {} as {
      결과유무: boolean
    },
  },
  '교재주문/결제_쿠폰추가하기btn': {
    eventCode: 'T32-26',
    eventName: '교재주문/결제_쿠폰추가하기btn',
    eventProps: {} as {
      쿠폰혜택: string
      쿠폰혜택값: number
      쿠폰이름: string
      쿠폰ID: number
    },
  },

  시그니처교재_학부모가결제탭_클릭: {
    eventCode: 'T32-27',
    eventName: '시그니처교재_학부모가결제탭_클릭',
  },
  시그니처교재_학부모가결제탭_담기클릭: {
    eventCode: 'T32-28',
    eventName: '시그니처교재_학부모가결제탭_담기클릭',
  },
  시그니처교재_학부모가결제_구매요청클릭: {
    eventCode: 'T32-29',
    eventName: '시그니처교재_학부모가결제_구매요청클릭',
  },
  시그니처교재_학부모가결제_모달내_보내기클릭: {
    eventCode: 'T32-30',
    eventName: '시그니처교재_학부모가결제_모달내_보내기클릭',
  },
  시그니처교재_가격토글클릭: {
    eventCode: 'T32-31',
    eventName: '시그니처교재_가격토글클릭',
    eventProps: {} as { 가격표시: boolean },
  },
  내교재_학부모가결제탭_클릭: {
    eventCode: 'T32-32',
    eventName: '내교재_학부모가결제탭_클릭',
  },
  내교재_학부모가결제탭_담기클릭: {
    eventCode: 'T32-33',
    eventName: '내교재_학부모가결제탭_담기클릭',
  },
  내교재_학부모가결제_구매요청클릭: {
    eventCode: 'T32-34',
    eventName: '내교재_학부모가결제_구매요청클릭',
  },
  내교재_학부모가결제_모달내_보내기클릭: {
    eventCode: 'T32-35',
    eventName: '내교재_학부모가결제_모달내_보내기클릭',
  },
  내교재_가격토글클릭: {
    eventCode: 'T32-36',
    eventName: '내교재_가격토글클릭',
    eventProps: {} as { 가격표시: boolean },
  },
  장바구니_학부모가결제탭_PV: {
    eventCode: 'T32-37',
    eventName: '장바구니_학부모가결제탭_PV',
  },
  장바구니_학부모가결제탭내_구매요청클릭: {
    eventCode: 'T32-38',
    eventName: '장바구니_학부모가결제탭내_구매요청클릭',
  },
  장바구니_학부모가결제_모달내_보내기클릭: {
    eventCode: 'T32-39',
    eventName: '장바구니_학부모가결제_모달내_보내기클릭',
  },
  학부모결제완료후팝업내_정산정보입력버튼클릭: {
    eventCode: 'T32-40',
    eventName: '학부모결제완료후팝업내_정산정보입력버튼클릭',
  },
  주문내역_학부모구매_PV: {
    eventCode: 'T32-41',
    eventName: '주문내역_학부모구매_PV',
  },
  주문내역_학부모구매_주문상세_버튼클릭: {
    eventCode: 'T32-42',
    eventName: '주문내역_학부모구매_주문상세_버튼클릭',
  },
  주문내역_학부모주문상세의주문취소_클릭: {
    eventCode: 'T32-43',
    eventName: '주문내역_학부모주문상세의주문취소_클릭',
  },
  주문내역_학부모주문상세의재발송_클릭: {
    eventCode: 'T32-44',
    eventName: '주문내역_학부모주문상세의재발송_클릭',
  },
  주문내역_학부모주문상세의직접결제_클릭: {
    eventCode: 'T32-45',
    eventName: '주문내역_학부모주문상세의직접결제_클릭',
  },
  주문내역_학부모주문상세의장바구니담기_클릭: {
    eventCode: 'T32-46',
    eventName: '주문내역_학부모주문상세의장바구니담기_클릭',
  },

  시그니처교재_학부모가결제_모달내_가이드영상클릭: {
    eventCode: 'T32-47',
    eventName: '시그니처교재_학부모가결제_모달내_가이드영상클릭',
  },
  '시그니처교재_100%기능이해하기클릭': {
    eventCode: 'T32-48',
    eventName: '시그니처교재_100%기능이해하기클릭',
  },
  '시그니처교재_100%기능이해하기_학부모결제클릭': {
    eventCode: 'T32-49',
    eventName: '시그니처교재_100%기능이해하기_학부모결제클릭',
  },
  시그니처교재_학부모가결제탭_스피치버블_자세히보기클릭: {
    eventCode: 'T32-50',
    eventName: '시그니처교재_학부모가결제탭_스피치버블_자세히보기클릭',
  },
  내교재_학부모가결제_모달내_가이드영상클릭: {
    eventCode: 'T32-51',
    eventName: '내교재_학부모가결제_모달내_가이드영상클릭',
  },
  내교재_학부모가결제탭_스피치버블_자세히보기클릭: {
    eventCode: 'T32-52',
    eventName: '내교재_학부모가결제탭_스피치버블_자세히보기클릭',
  },
  학부모결제페이지_결제하기_클릭: {
    eventCode: 'T32-53',
    eventName: '학부모결제페이지_결제하기_클릭',
  },
  학부모결제페이지_결제완료페이지_PV: {
    eventCode: 'T32-54',
    eventName: '학부모결제페이지_결제완료페이지_PV',
  },

  시중교재_예시문항보기_토글: {
    eventCode: 'T35-03',
    eventName: '시중교재_예시문항보기_토글',
    eventProps: {} as { toggle: 'ON' | 'OFF' },
  },
  시그니처교재_다운로드: {
    eventCode: 'T32-16',
    eventName: '시그니처교재_다운로드',
  },
  시그니처_수업보기모드: {
    eventCode: 'T43-01',
    eventName: '시그니처_수업보기모드',
  },
  '[학습지]_문풀동_안내배너_컨설팅_유도_click': {
    eventCode: 'T42-18',
    eventName: '[학습지]_문풀동_안내배너_컨설팅_유도_click',
  },
  '[교재]_문풀동_안내배너_컨설팅_유도_click': {
    eventCode: 'T43-09',
    eventName: '[교재]_문풀동_안내배너_컨설팅_유도_click',
  },
  유형분석_개별학생_PV: {
    eventCode: 'T46-01',
    eventName: '유형분석_개별학생_PV',
    eventProps: {} as { 실제_학년: number; '학기/과목'?: string; 최초진입: boolean },
  },
  유형분석_필터_추천유형토글_API: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_추천유형토글_API',
    eventProps: {} as {
      '추천유형칩만 보기': boolean
    },
  },
  유형분석_필터_과거학습이력_API: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_과거학습이력_API',
    eventProps: {} as {
      선택일: string
    },
  },
  '유형분석_필터_등급별 선택_API': {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_등급별 선택_API',
    eventProps: {} as {
      '학년-학기/과목'?: string
      등급: ConceptChipDomain.LevelOfAchievement
    },
  },
  '유형분석_필터_중단원 선택_API': {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_중단원 선택_API',
    eventProps: {} as {
      '학년-학기/과목'?: string
      소단원명: string
    },
  },
  '유형분석_필터_소단원 선택_API': {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_소단원 선택_API',
    eventProps: {} as {
      '학년-학기/과목'?: string
      소단원명: string
    },
  },
  '유형분석_필터_난이도 선택_API': {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_난이도 선택_API',
    eventProps: {} as {
      '학년-학기/과목'?: string
      난이도: ConceptChipEntity.AchievementConceptChip['conceptChipType']
    },
  },
  '유형분석_필터_중단원 아코디언_API': {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_중단원 아코디언_API',
    eventProps: {} as {
      '학년-학기/과목'?: string
      중단원명: string
      펼침여부: boolean
    },
  },
  유형분석_필터_시그니처교재_API: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_시그니처교재_API',
    eventProps: {} as {
      '한 번에 선택된 시그니처교재 개수': number
      '학기/과목별 시그니처교재명': string[]
      '학년-학기/과목'?: string
    },
  },
  유형분석_필터_시중교재_API: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_시중교재_API',
    eventProps: {} as {
      '한 번에 선택된 시중교재 개수': number
      '학기/과목별 시중교재명': string[]
      '학년-학기/과목'?: string
    },
  },
  유형분석_필터_교과서_API: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_교과서_API',
    eventProps: {} as {
      '한 번에 선택된 교과서 개수': number
      '학기/과목별 교과서명': string[]
      '학년-학기/과목'?: string
    },
  },
  유형분석_상세정보_API: {
    eventCode: 'T46-02',
    eventName: '유형분석_상세정보_API',
    eventProps: {} as {
      '선택한 유형칩 수': number
    } & Record<'white' | 'gray' | 'sad' | 'red' | 'yellow' | 'green' | 'smile', number>,
  },
  '유형분석_상세정보_정답/해설_API': {
    eventCode: 'T46-02',
    eventName: '유형분석_상세정보_정답/해설_API',
    eventProps: {} as {
      '학기/과목'?: string
    },
  },
  유형분석_출제모달_유형별학습지_API: {
    eventCode: 'T46-03',
    eventName: '유형분석_출제모달_유형별학습지_API',
    eventProps: {} as {
      '선택한 유형칩 수': number
      '설정한 유형칩별 문제 수': number | null
      자동채점: boolean
      '채점한 문제제외': boolean | undefined
      '모의고사 제외': boolean
      '바로 다운로드': boolean
    } & Record<'white' | 'gray' | 'sad' | 'red' | 'yellow' | 'green' | 'smile', number>,
  },
  유형분석_출제모달_유형별오답학습지_API: {
    eventCode: 'T46-03',
    eventName: '유형분석_출제모달_유형별오답학습지_API',
    eventProps: {} as {
      '선택한 유형칩 수': number
      '설정한 옵션': string
      '쌍둥이 문제수': number | null
      자동채점: boolean
      '채점한 문제제외': boolean | undefined
      '바로 다운로드': boolean
    },
  },
  유형분석_필터_학교별기출: {
    eventCode: 'T46-01',
    eventName: '유형분석_필터_학교별기출',
  },

  생성완료_유형분석_보고서: {
    eventCode: 'T46-01',
    eventName: '생성완료_유형분석_보고서',
    eventProps: {} as {
      표지: boolean
      코멘트: boolean
      '학기/과목': string
      '교재/학습지': boolean
      추천유형: boolean
      최초생성여부: 'CREATE' | 'MODIFY'
    },
  },

  유형분석_보고서_AI코멘트: {
    eventCode: 'T46-01',
    eventName: '유형분석_보고서_AI코멘트',
    eventProps: {} as {
      생성완료: boolean
    },
  },

  유형분석_보고서_미리보기: {
    eventCode: 'T46-01',
    eventName: '유형분석_보고서_미리보기',
  },
  유형분석_보고서_문자발송: {
    eventCode: 'T46-01',
    eventName: '유형분석_보고서_문자발송',
  },

  유형분석_보고서_링크복사: {
    eventCode: 'T46-01',
    eventName: '유형분석_보고서_링크복사',
  },

  경시대회_LNB_대회소개_클릭: {
    eventCode: 'T70-02',
    eventName: '경시대회_LNB_대회소개_클릭',
  },
  경시대회_LNB_시행안내_클릭: {
    eventCode: 'T70-03',
    eventName: '경시대회_LNB_시행안내_클릭',
  },
  경시대회_LNB_응시하기_클릭: {
    eventCode: 'T70-04',
    eventName: '경시대회_LNB_응시하기_클릭',
  },
  경시대회_LNB_상장배너신청_클릭: {
    eventCode: 'T70-05',
    eventName: '경시대회_LNB_상장배너신청_클릭',
  },
  경시대회_샘플시험지다운로드: {
    eventCode: 'T70-06',
    eventName: '경시대회_샘플시험지다운로드',
  },
  경시대회_샘플보고서다운로드: {
    eventCode: 'T70-07',
    eventName: '경시대회_샘플보고서다운로드',
  },
  경시대회_홍보이미지다운로드: {
    eventCode: 'T70-08',
    eventName: '경시대회_홍보이미지다운로드',
  },
  경시대회_출제하기: {
    eventCode: 'T70-09',
    eventName: '경시대회_출제하기',
  },
  경시대회_상장배너결제하기: {
    eventCode: 'T70-10',
    eventName: '경시대회_상장배너결제하기',
  },

  가상학생등록완료: {
    eventCode: 'T71-01',
    eventName: '가상학생등록완료',
    eventProps: {} as {
      academy: Academy
    },
  },
  가상학생등록실패: {
    eventCode: 'T71-02',
    eventName: '가상학생등록실패',
  },
  일괄채점_일괄오답학습지_학생별: {
    eventCode: 'T42-12',
    eventName: '일괄채점_일괄오답학습지_학생별',
    eventProps: {} as {
      출제방식: string
      자동채점: boolean
      출제된_문제_제외: boolean
    },
  },
  정복_프로필_클릭: {
    eventCode: 'T99-03',
    eventName: '정복_프로필_클릭',
    eventProps: {
      동작: undefined as '열기' | '닫기' | undefined,
    },
  },
  정복_기능카드_클릭: {
    eventCode: 'T99-03',
    eventName: '정복_기능카드_클릭',
    eventProps: {
      단계: undefined as 메인시나리오단계,
      상태: undefined as
        | undefined
        | ReturnType<(typeof ScenarioService)['prototype']['getScenarioStatus']>,
    },
  },
  정복_기능카드_네비게이션클릭: {
    eventCode: 'T99-03',
    eventName: '정복_기능카드_네비게이션클릭',
    eventProps: {
      방향: undefined as undefined | '왼쪽' | '오른쪽',
    },
  },
  정복_설명팝업_CTA버튼: {
    eventCode: 'T99-03',
    eventName: '정복_설명팝업_CTA버튼',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_설명팝업_노출: {
    eventCode: 'T99-03',
    eventName: '정복_설명팝업_노출',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_설명팝업_포인터타겟클릭: {
    eventCode: 'T99-03',
    eventName: '정복_설명팝업_포인터타겟클릭',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_설명팝업_동영상링크: {
    eventCode: 'T99-03',
    eventName: '정복_설명팝업_동영상링크',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_완료팝업_닫기: {
    eventCode: 'T99-03',
    eventName: '정복_완료팝업_닫기',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_완료팝업_다음버튼: {
    eventCode: 'T99-03',
    eventName: '정복_완료팝업_다음버튼',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_완료팝업_노출: {
    eventCode: 'T99-03',
    eventName: '정복_완료팝업_노출',
    eventProps: {
      단계: undefined as 메인시나리오단계,
    },
  },
  정복_좋아요카드_좋아요: {
    eventCode: 'T99-03',
    eventName: '정복_좋아요카드_좋아요',
    eventProps: {
      단계: undefined as 서브시나리오단계,
    },
  },
  정복_좋아요카드_좋아요취소: {
    eventCode: 'T99-03',
    eventName: '정복_좋아요카드_좋아요취소',
    eventProps: {
      단계: undefined as 서브시나리오단계,
    },
  },
  정식가입하러가기툴팁_신청하기클릭: {
    eventCode: 'T99-04',
    eventName: '정식가입하러가기툴팁_신청하기클릭',
    eventProps: undefined,
  },
  정식가입하러가기툴팁_닫기: {
    eventCode: 'T99-04',
    eventName: '정식가입하러가기툴팁_닫기',
    eventProps: undefined,
  },
  정식가입하러가기_내정보_신청하기클릭: {
    eventCode: 'T99-04',
    eventName: '정식가입하러가기_내정보_신청하기클릭',
    eventProps: undefined,
  },
  생성완료학습지_단원유형별: {
    eventCode: 'T31-01',
    eventName: '생성완료학습지_단원유형별',
    eventProps: {} as 학습지_단원유형별,
  },
  생성완료학습지_시중교재: {
    eventCode: 'T31-01',
    eventName: '생성완료학습지_시중교재',
    eventProps: {} as 학습지_시중교재,
  },
  생성완료학습지_시그니처교재: {
    eventCode: 'T31-01',
    eventName: '생성완료학습지_시그니처교재',
    eventProps: {} as 학습지_시그니처교재,
  },
  생성완료학습지_수능모의고사: {
    eventCode: 'T31-01',
    eventName: '생성완료학습지_수능모의고사',
    eventProps: {} as 학습지_수능모의고사,
  },
  생성완료학습지_기출업로드: {
    eventCode: 'T31-01',
    eventName: '생성완료학습지_기출업로드',
    eventProps: {} as 학습지_기출업로드<'SCHOOL_TEST_PAPER'> | 학습지_기출업로드<'CUSTOM_PAPER'>,
  },
  생성완료학습지_원클릭복습: {
    eventCode: 'T42-05',
    eventName: '생성완료학습지_원클릭복습',
    eventProps: {} as 학습지_원클릭복습,
  },
  학생지공개상태모달: {
    eventCode: 'T31-10',
    eventName: '학생지공개상태모달',
    eventProps: {} as {
      상태: '비공개' | '공개'
    },
  },
  테마별학습지_출제하기: {
    eventCode: 'T33-00',
    eventName: '테마별학습지_출제하기',
    eventProps: {
      학제: null,
      출판사: null,
      학생수: null,
    } as {
      학제: Worksheet['schoolType'] | null
      출판사: Worksheet['publisher'] | null
      학생수: number | null
    },
  },
  테마별학습지_일괄출제: {
    eventCode: 'T33-00',
    eventName: '테마별학습지_일괄출제',
    eventProps: {
      학습지수: null,
    } as {
      학습지수: number | null
    },
  },
  테마별학습지_다운로드: {
    eventCode: 'T33-00',
    eventName: '테마별학습지_다운로드',
    eventProps: {
      학습지수: null,
    } as {
      학습지수: number | null
    },
  },
  테마별학습지_인쇄: {
    eventCode: 'T33-00',
    eventName: '테마별학습지_인쇄',
    eventProps: {
      학습지수: null,
    } as {
      학습지수: number | null
    },
  },
  VOD아티클목록조회: {
    eventCode: 'T56-01',
    eventName: 'VOD아티클목록조회',
  },
  VOD아티클상세조회: {
    eventCode: 'T56-02',
    eventName: 'VOD아티클상세조회',
  },
  VOD아티클상세_동영상실행: {
    eventCode: 'T56-03',
    eventName: 'VOD아티클상세_동영상실행',
  },
  VOD아티클상세_PDF다운받기: {
    eventCode: 'T56-04',
    eventName: 'VOD아티클상세_PDF다운받기',
  },
  VOD아티클상세_질문의견남기기: {
    eventCode: 'T56-05',
    eventName: 'VOD아티클상세_질문의견남기기',
  },
  VOD아티클상세_정식가입하기: {
    eventCode: 'T56-06',
    eventName: 'VOD아티클상세_정식가입하기(무료체험자)',
  },
  시그니처교재_1단원PDF다운로드_내보내기: {
    eventCode: 'T32-18',
    eventName: '시그니처교재_1단원PDF다운로드/내보내기_선택',
    eventProps: {
      workbookId: null,
      workbookTitle: '',
      workbookFullTitle: '',
      시그니처교재타입: null,
    } as {
      workbookId: number | null
      workbookTitle: string
      workbookFullTitle: string | undefined
      시그니처교재타입:
        | '체험교재'
        | '구매교재'
        | '대여교재'
        | '미구매교재'
        | '표지_편집용_체험교재'
        | null
    },
  },
  시그니처교재_문제지_PDF다운로드선택: {
    eventCode: 'T32-18',
    eventName: '시그니처교재_문제지_PDF다운로드선택',
    eventProps: {
      workbookId: null,
      workbookTitle: '',
      workbookFullTitle: '',
      시그니처교재타입: null,
    } as {
      workbookId: number | null
      workbookTitle: string
      workbookFullTitle: string | undefined
      시그니처교재타입:
        | '체험교재'
        | '구매교재'
        | '대여교재'
        | '미구매교재'
        | '표지_편집용_체험교재'
        | null
    },
  },
  시그니처교재_정답해설PDF다운로드_내보내기: {
    eventCode: 'T32-19',
    eventName: '시그니처교재_정답해설PDF다운로드/내보내기_선택',
    eventProps: {
      workbookId: null,
      workbookTitle: '',
      workbookFullTitle: '',
      시그니처교재타입: null,
    } as {
      workbookId: number | null
      workbookTitle: string
      workbookFullTitle: string | undefined
      시그니처교재타입:
        | '체험교재'
        | '구매교재'
        | '대여교재'
        | '미구매교재'
        | '표지_편집용_체험교재'
        | null
    },
  },
  시그니처교재_출제하기: {
    eventCode: 'T32-17',
    eventName: '시그니처교재_출제하기',
    eventProps: {
      workbookId: null,
      시그니처교재타입: null,
    } as {
      workbookId: number | null
      시그니처교재타입:
        | '체험교재'
        | '구매교재'
        | '대여교재'
        | '미구매교재'
        | '표지_편집용_체험교재'
        | null
    },
  },
  시그니처교재_체험교재가이드선택: {
    eventCode: 'T32-20',
    eventName: '시그니처교재_체험교재가이드선택',
  },
  시그니처교재_정식가입_정식가입하기선택: {
    eventCode: 'T32-21',
    eventName: '시그니처교재_정식가입_정식가입하기선택',
  },
  내교재_정식가입_정식가입하기선택: {
    eventCode: 'T32-21',
    eventName: '내교재_정식가입_정식가입하기선택',
  },
  장바구니_정식가입_정식가입하기선택: {
    eventCode: 'T32-21',
    eventName: '장바구니_정식가입_정식가입하기선택',
  },
  커스텀프린트_정식가입_정식가입하기선택: {
    eventCode: 'T32-21',
    eventName: '커스텀프린트_정식가입_정식가입하기선택',
  },
  시그니처교재_구매한교재만보기: {
    eventCode: 'T32-22',
    eventName: '시그니처교재_구매한교재만보기',
    eventProps: {
      to: null,
    } as {
      to: boolean | null
    },
  },
  시그니처교재_교재주문하기선택: {
    eventCode: 'T32-23',
    eventName: '시그니처교재_교재주문하기선택',
  },
  시그니처교재_주문배송조회선택: {
    eventCode: 'T32-24',
    eventName: '시그니처교재_주문배송조회선택',
  },
  학습내역_해설버튼: {
    eventCode: 'T41-02',
    eventName: '학습내역_해설버튼',
    eventProps: { 필기유무: null, to: null } as {
      필기유무: boolean | null
      to: boolean | null
    },
  },
  학습내역_필기미리보기: {
    eventCode: 'T41-02',
    eventName: '학습내역_필기미리보기',
    eventProps: { 필기유무: null, to: null } as {
      필기유무: boolean | null
      to: boolean | null
    },
  },
  개인학습지채점_해설버튼: {
    eventCode: 'T42-06',
    eventName: '개인학습지채점_해설버튼',
    eventProps: { 필기유무: null } as {
      필기유무: boolean | null
    },
  },
  개인학습지채점_필기미리보기: {
    eventCode: 'T42-06',
    eventName: '개인학습지채점_필기미리보기',
    eventProps: { 필기유무: null } as {
      필기유무: boolean | null
    },
  },
  유형분석상세_해설버튼: {
    eventCode: 'T46-02',
    eventName: '유형분석상세_해설버튼',
    eventProps: {
      필기유무: null as boolean | null,
      to: null as boolean | null,
      type: null as res.AchievementStudyLog['type'] | null,
      subType: null as string | null,
      contentTitle: null as res.AchievementStudyLog['contentTitle'] | null,
      contentProblemNumber: null as res.AchievementStudyLog['contentProblemNumber'] | null,
      contentPageNumber: null as res.AchievementStudyLog['contentPageNumber'] | null,
      result: null as res.AchievementStudyLog['result'] | null,
      datetime: null as res.AchievementStudyLog['datetime'] | null,
      orderNumber: null as res.AchievementStudyLog['orderNumber'] | null,
    },
  },
  유형분석상세정보_필기미리보기: {
    eventCode: 'T46-02',
    eventName: '유형분석상세정보_필기미리보기',
    eventProps: {
      type: null as res.AchievementStudyLog['type'] | null,
      subType: null as string | null,
      contentTitle: null as res.AchievementStudyLog['contentTitle'] | null,
      contentProblemNumber: null as res.AchievementStudyLog['contentProblemNumber'] | null,
      contentPageNumber: null as res.AchievementStudyLog['contentPageNumber'] | null,
      result: null as res.AchievementStudyLog['result'] | null,
      datetime: null as res.AchievementStudyLog['datetime'] | null,
      orderNumber: null as res.AchievementStudyLog['orderNumber'] | null,
    },
  },
  학습지_현황_PV: {
    eventCode: 'T42_01',
    eventName: '학습지_현황_PV',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
      오답학습제외: false,
    },
  },

  학습지_현황_그룹채점이동: {
    eventCode: 'T42_01',
    eventName: '학습지_현황_그룹채점이동',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  학습지_현황_개인채점이동: {
    eventCode: 'T42_01',
    eventName: '학습지_현황_개인채점이동',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  학습지_현황_출제변경: {
    eventCode: 'T42_01',
    eventName: '학습지_현황_출제변경',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  학습지_현황_엑셀다운로드: {
    eventCode: 'T42_01',
    eventName: '학습지_현황_엑셀다운로드',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
      기간단위: true,
      선택한기간: '',
    },
  },

  교재_현황_PV: {
    eventCode: 'T03_01',
    eventName: '교재_현황_PV',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      교재타입: '',
      교재명: '',
      '학년/반': true,
    },
  },

  교재_현황_그룹채점이동: {
    eventCode: 'T03_01',
    eventName: '교재_현황_그룹채점이동',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  교재_현황_개인채점이동: {
    eventCode: 'T03_01',
    eventName: '교재_현황_개인채점이동',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  학습통계_PV: {
    eventCode: 'T41_03',
    eventName: '학습통계_PV',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
    },
  },

  학습통계_엑셀다운로드: {
    eventCode: 'T41_03',
    eventName: '학습통계_엑셀다운로드',
    eventProps: {
      고객분류: undefined as res.Academy['customerType'] | undefined,
      '학년/반': true,
      기간단위: true,
      선택한기간: '',
    },
  },
  // 학교별 기출 - 학습지 만들기
  학교별기출학습지_학습지만들기: {
    eventCode: 'T35-13',
    eventName: '학교별기출학습지_학습지만들기',
    eventProps: {
      Sch_Exam_Region: undefined as string | undefined, // 지역 (ex. 서울_강남구, 경기_안양시)
      Sch_Exam_School: undefined as string | undefined, // 학교 (ex. 서울_강남구_개포중학교)
      Sch_Exam_Grade: undefined as string | undefined, // 학년/학기/과목-시험유형 (ex. 초3-2/중간)
      Sch_Exam_Year: undefined as string | undefined, // 기출연도 (ex. 2024, 2023, 2021)
      Sch_Exam_TwinsSimilar: undefined as string | undefined, // 쌍둥이 문제/유사문제 배수 선택 (ex. Twins3-Similar1)
      Sch_Exam_Level: undefined as string | undefined, // 난이도 (ex. 더쉽게 / 그대로 / 어렵게)
      Sch_Exam_Count: undefined as number | undefined, // 문제수: number
      Sch_Exam_Temple: undefined as string | undefined, // 학습지 템플릿 정보 (ex. 템플릿 명)
    },
  },
  학교별기출학습지_지역학교선택: {
    eventCode: 'T35-13',
    eventName: '학교별기출학습지_지역학교선택',
    eventProps: {
      Sch_Search_Region: undefined as string | undefined, // 지역 (ex. 서울_강남구, 경기_안양시)
      Sch_Search_School: undefined as string | undefined, // 학교 (ex. 서울_강남구_개포중학교)
    },
  },
  학교별기출학습지_학교명검색: {
    eventCode: 'T35-13',
    eventName: '학교별기출학습지_학교명검색',
    eventProps: {
      Sch_Search_Keyword: undefined as string | undefined, // 고객의 모든 검색어 집계 (string)
      Sch_Search_Exist: undefined as boolean | undefined, // 고객 입장에서의 검색 실패/좌절 (=null) 확인
    },
  },

  시그니처교재_복제후수정btn: {
    eventCode: 'T32-13',
    eventName: '시그니처교재_복제후수정btn',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      signatureWorkbookFulltitle: WorkbookEntity.CustomSignatureWorkbook['signatureWorkbookFulltitle']
      signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType'] // 교재타입
      grade: WorkbookEntity.CustomSignatureWorkbook['grade'] // 학년, 과목
      semester: WorkbookEntity.CustomSignatureWorkbook['semester'] // 학기
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재_수정btn: {
    eventCode: 'T32-13',
    eventName: '시그니처교재_수정btn',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      signatureWorkbookFulltitle: WorkbookEntity.CustomSignatureWorkbook['signatureWorkbookFulltitle']
      signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType'] // 교재타입
      grade: WorkbookEntity.CustomSignatureWorkbook['grade'] // 학년, 과목
      semester: WorkbookEntity.CustomSignatureWorkbook['semester'] // 학기
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재_삭제btn: {
    eventCode: 'T32-13',
    eventName: '시그니처교재_삭제btn',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      signatureWorkbookFulltitle: WorkbookEntity.CustomSignatureWorkbook['signatureWorkbookFulltitle']
      signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType'] // 교재타입
      grade: WorkbookEntity.CustomSignatureWorkbook['grade'] // 학년, 과목
      semester: WorkbookEntity.CustomSignatureWorkbook['semester'] // 학기
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재_구매하기btn: {
    eventCode: 'T32-13',
    eventName: '시그니처교재_구매하기btn',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      signatureWorkbookFulltitle: WorkbookEntity.CustomSignatureWorkbook['signatureWorkbookFulltitle']
      signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType'] // 교재타입
      grade: WorkbookEntity.CustomSignatureWorkbook['grade'] // 학년, 과목
      semester: WorkbookEntity.CustomSignatureWorkbook['semester'] // 학기
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재상세보기_PV: {
    eventCode: 'T32-23',
    eventName: '시그니처교재상세보기_PV',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      grade: SignatureProductDetailEntity.ProductDetail['grade'] // 학년, 과목
      semester: SignatureProductDetailEntity.ProductDetail['semester'] // 학기
      name: SignatureProductDetailEntity.ProductDetail['name'] // 교재명
      type: SignatureProductDetailEntity.ProductDetail['type'] // 교재타입
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재상세보기_표지편집btn: {
    eventCode: 'T32-23',
    eventName: '시그니처교재상세보기_표지편집btn',
    eventProps: {} as {
      id: WorkbookEntity.CustomSignatureWorkbook['id']
      grade: SignatureProductDetailEntity.ProductDetail['grade'] // 학년, 과목
      semester: SignatureProductDetailEntity.ProductDetail['semester'] // 학기
      name: SignatureProductDetailEntity.ProductDetail['name'] // 교재명
      type: SignatureProductDetailEntity.ProductDetail['type'] // 교재타입
      schoolType: WorkbookEntity.CustomSignatureWorkbook['schoolType'] // 학제
    },
  },
  시그니처교재만들기_Step2_저장btn: {
    eventCode: 'T32-20',
    eventName: '시그니처교재만들기_Step2_저장btn',
    eventProps: {} as ReturnType<typeof convertSignatureWorkbookDataForDataTracking>,
  },
  시그니처교재만들기_Step2_저장완료btn: {
    eventCode: 'T32-20',
    eventName: '시그니처교재만들기_Step2_저장완료btn',
    eventProps: {} as ReturnType<typeof convertSignatureWorkbookDataForDataTracking>,
  },
  시그니처교재만들기_Step2_이전btn: {
    eventCode: 'T32-20',
    eventName: '시그니처교재만들기_Step2_이전btn',
    eventProps: {} as { workbook: WorkbookEntity.Workbook | undefined },
  },

  실험실_AI튜터: {
    eventCode: 'T57-01',
    eventName: '실험실_AI튜터',
    eventProps: {} as { 사용설정: boolean },
  },

  실험실_유형분석보고서: {
    eventCode: 'T57-02',
    eventName: '실험실_유형분석보고서',
    eventProps: {} as { 사용설정: boolean },
  },
  실험실_원클릭복습: {
    eventCode: 'T57-02',
    eventName: '실험실_원클릭복습',
    eventProps: {} as { 사용설정: boolean },
  },

  매쓰플랫알림판: {
    eventCode: 'T99-01',
    eventName: '매쓰플랫알림판',
    eventProps: {} as {
      타이틀: string
      메모: string
      영상유무: boolean
      이미지유무: boolean
      최초조회: boolean
      버튼링크유무: boolean
    },
  },

  매쓰플랫알림판_일반닫기: {
    eventCode: 'T99-01',
    eventName: '매쓰플랫알림판_일반닫기',
  },

  매쓰플랫알림판_3일동안닫기: {
    eventCode: 'T99-01',
    eventName: '매쓰플랫알림판_3일동안닫기',
  },

  매쓰플랫알림판_링크버튼_Click: {
    eventCode: 'T99-01',
    eventName: '매쓰플랫알림판_링크버튼_Click',
    eventProps: {} as {
      타이틀: string
      메모: string
      영상유무: boolean
      이미지유무: boolean
      최초조회: boolean
      버튼링크유무: boolean
    },
  },

  내교재목록_교재만들기btn: {
    eventCode: 'T32-01',
    eventName: '내교재목록_교재만들기btn',
  },
  내교재목록_구매하기btn: {
    eventCode: 'T32-01',
    eventName: '내교재목록_구매하기btn',
    eventProps: {
      교재종류: '',
      교재학교급: '',
      교재학년: '' as string | number,
      교재학기: null as import('@mathflat/domain/@entities/SchoolSystem/schema').Semester | null,
      페이지수: undefined as number | undefined,
    },
  },
  내교재목록_담기btn: {
    eventCode: 'T32-01',
    eventName: '내교재목록_담기btn',
    eventProps: {
      교재종류: '',
      교재학교급: '',
      교재학년: '' as string | number,
      교재학기: null as import('@mathflat/domain/@entities/SchoolSystem/schema').Semester | null,
      답지옵션: '',
      페이지수: null as number | null | undefined,
    },
  },
  내교재목록_주문하기btn: {
    eventCode: 'T32-01',
    eventName: '내교재목록_주문하기btn',
    eventProps: {
      교재종류: '',
      교재학교급: '',
      교재학년: '' as string | number,
      교재학기: null as import('@mathflat/domain/@entities/SchoolSystem/schema').Semester | null,
      답지옵션: '',
      페이지수: null as number | null | undefined,
    },
  },
  내교재목록_토스트_장바구니바로가기btn: {
    eventCode: 'T32-01',
    eventName: '내교재목록_토스트_장바구니바로가기btn',
  },
  교재만들기1단계_닫기btn: {
    eventCode: 'T36-01',
    eventName: '교재만들기1단계_닫기btn',
  },
  교재만들기1단계_다음단계btn: {
    eventCode: 'T36-01',
    eventName: '교재만들기1단계_다음단계btn',
  },
  교재만들기2단계_이전btn: {
    eventCode: 'T36-02',
    eventName: '교재만들기2단계_이전btn',
    eventProps: {
      생성수정타입: '' as '생성' | '수정' | '복제후수정' | '출제된 학습지 수정',
    },
  },
  교재만들기2단계_닫기btn: {
    eventCode: 'T36-02',
    eventName: '교재만들기2단계_닫기btn',
    eventProps: {
      생성수정타입: '' as '생성' | '수정' | '복제후수정' | '출제된 학습지 수정',
    },
  },
  교재만들기2단계_다음단계btn: {
    eventCode: 'T36-02',
    eventName: '교재만들기2단계_다음단계btn',
    eventProps: {
      생성수정타입: '' as '생성' | '수정' | '복제후수정' | '출제된 학습지 수정',
    },
  },
  교재만들기3단계_이전단계btn: {
    eventCode: 'T36-09',
    eventName: '교재만들기3단계_이전단계btn',
    eventProps: {
      생성수정타입: '' as '생성' | '수정' | '복제후수정' | '출제된 학습지 수정',
    },
  },
  교재만들기3단계_닫기btn: {
    eventCode: 'T36-09',
    eventName: '교재만들기3단계_닫기btn',
    eventProps: {
      생성수정타입: '' as '생성' | '수정' | '복제후수정' | '출제된 학습지 수정',
    },
  },
  마이리스트_목록: {
    eventCode: 'T31-01',
    eventName: '마이리스트_목록',
    eventProps: {
      목록: [] as { 마이리스트명: string; '포함 학습지 개수': number }[],
      마이리스트명: [] as string[],
      '포함 학습지 개수': [] as number[],
      개수: 0 as number,
      정렬: true as boolean, // ‘true = 생성순’, ‘false = 이름순’ => 한글로 보내도 되는지 확인할 것
    },
  },
  마이리스트_생성완료: {
    eventCode: 'T31-01',
    eventName: '마이리스트_생성완료',
    eventProps: {
      마이리스트명: '' as string,
      글자수: 0 as number,
    },
  },
  마이리스트_만들기_BTN: {
    eventCode: 'T31-01',
    eventName: '마이리스트_만들기_btn_Click',
  },

  학습지채점_문풀동_모달: {
    eventCode: '',
    eventName: '[수업] 학습지채점_문풀동_모달',
    eventProps: {
      '학제/학년': '' as string,
      문제id: undefined as number | undefined,
      비디오id: undefined as number | undefined,
    },
  },

  교재채점_문풀동_모달: {
    eventCode: '',
    eventName: '[수업] 교재채점_문풀동_모달',
    eventProps: {
      '학년/학기': '' as string,
      문제id: undefined as number | undefined,
      비디오id: undefined as number | undefined,
    },
  },

  학습지채점_문풀동_재생: {
    eventCode: '',
    eventName: '[수업] 학습지채점_문풀동_재생',
    eventProps: {
      '학제/학년': '' as string,
      문제id: undefined as number | undefined,
      비디오id: undefined as number | undefined,
    },
  },

  내교재채점_문풀동_재생: {
    eventCode: '',
    eventName: '[수업] 내교재채점_문풀동_재생',
    eventProps: {
      '학년/학기': '' as string,
      문제id: undefined as number | undefined,
      비디오id: undefined as number | undefined,
    },
  },

  시그니처교재채점_문풀동_재생: {
    eventCode: '',
    eventName: '[수업] 시그니처교재채점_문풀동_재생',
    eventProps: {
      '학년/학기': '' as string,
      문제id: undefined as number | undefined,
      비디오id: undefined as number | undefined,
      교재이름: '' as string,
    },
  },

  문제은행_문풀동_넛지배너_Click: {
    eventCode: '',
    eventName: '[수업] 문제은행_문풀동_넛지배너_Click',
    eventProps: {
      배너타입: '' as 'overlay' | 'outro',
    },
  },

  시그니처_문풀동_넛지배너_Click: {
    eventCode: '',
    eventName: '[수업] 시그니처_문풀동_넛지배너_Click',
    eventProps: {
      배너타입: '' as 'overlay' | 'outro',
    },
  },
  학생이용권_학생목록: {
    eventCode: '',
    eventName: '[스쿨] [학생관리] 학생이용권_학생목록',
    eventProps: {
      학교_이름: '',
      계약한_이용권_수: 0 as number | 'unlimited',
      사용중인_이용권_수: 0,
      이용권_사용_비율: 0 as number | 'unlimited',
    },
  },
  학생이용권_활성화: {
    eventCode: '',
    eventName: '[스쿨] [학생관리] 학생이용권_활성화',
    eventProps: {
      활성_경로: 'modal' as 'bottom sheet' | 'modal',
      이용권_사용_비율: 0 as number | 'unlimited',
      이용권_잔여_기간: 0 as number | '해지시',
    },
  },
  학생이용권_비활성화: {
    eventCode: '',
    eventName: '[스쿨] [학생관리] 학생이용권_비활성화',
    eventProps: {
      비활성_경로: 'modal' as 'bottom sheet' | 'modal',
      이용권_사용_비율: 0 as number | 'unlimited',
      이용권_잔여_기간: 0 as number | '해지시',
    },
  },
  학생이용권_상담신청: {
    eventCode: '',
    eventName: '[스쿨] [학생관리] 학생이용권_상담신청',
    eventProps: {
      학교_이름: '',
      신청_경로: '' as '띠배너' | '초과 모달' | '계약변경 안내 모달',
      이용권_사용_비율: 0 as number | 'unlimited',
      이용권_잔여_기간: 0 as number | '해지시',
    },
  },

  // 실시간 모니터링
  실시간모니터링_진입: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_진입',
    eventProps: {
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
      진입_경로: '' as '목록뷰' | '현황뷰',
    },
  },

  실시간모니터링_전체뷰_PV: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_전체뷰_PV',
    eventProps: {
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
    },
  },

  실시간모니터링_개별뷰_PV: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_개별뷰_PV',
    eventProps: {
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
    },
  },

  실시간모니터링_문제선택: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_문제선택',
    eventProps: {
      선택_경로: '' as '전체뷰' | '개별뷰',
      채점_상태: '' as
        | '채점_정답'
        | '채점_오답'
        | '채점_모름'
        | '채점전'
        | '가채점_정답'
        | '가채점_오답'
        | '가채점_모름',
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
    },
  },

  실시간모니터링_선생님필기: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_선생님필기',
    eventProps: {
      채점_상태: '' as
        | '채점전'
        | '채점_정답'
        | '채점_오답'
        | '채점_모름'
        | '가채점_정답'
        | '가채점_오답'
        | '가채점_모름',
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
    },
  },

  실시간모니터링_학습지교체: {
    eventCode: '',
    eventName: '[수업] 실시간모니터링_학습지교체',
    eventProps: {
      '학제/학년': '' as string,
      문제수: 0 as number,
      출제_학생수: 0 as number,
      학습지타입: '' as ReturnType<typeof worksheetUtil.getKorWorksheetFilterType>,
    },
  },

  내신관_학교별기출학습하기_단원별학습지: {
    eventCode: 'T61-01',
    eventName: '내신관_학교별기출학습하기_단원별학습지',
  },
  내신관_학교별기출학습하기_AI기출업로드: {
    eventCode: 'T61-01',
    eventName: '내신관_학교별기출학습하기_AI기출업로드',
  },
  내신관_학교별기출학습하기_학교내신기출시험지: {
    eventCode: 'T61-01',
    eventName: '내신관_학교별기출학습하기_학교내신기출시험지',
  },
  내신관_학교별기출학습하기_학교내신기출유사문제: {
    eventCode: 'T61-01',
    eventName: '내신관_학교별기출학습하기_학교내신기출유사문제',
  },
  내신관_학교별기출학습하기_인근지역의내신기출시험지: {
    eventCode: 'T61-01',
    eventName: '내신관_학교별기출학습하기_인근지역의내신기출시험지',
  },
  내신관_출판사별교과서대비하기_교과서빈출기반학습지: {
    eventCode: 'T61-02',
    eventName: '내신관_출판사별교과서대비하기_교과서빈출기반학습지',
  },
  내신관_출판사별교과서대비하기_교과서별내신대비문제: {
    eventCode: 'T61-02',
    eventName: '내신관_출판사별교과서대비하기_교과서별내신대비문제',
  },
  내신관_학생별취약유형잡아주기_유형분석: {
    eventCode: 'T61-03',
    eventName: '내신관_학생별취약유형잡아주기_유형분석',
  },
  내신관_학생별취약유형잡아주기_시그니처교재: {
    eventCode: 'T61-03',
    eventName: '내신관_학생별취약유형잡아주기_시그니처교재',
  },
  내신관_학교별기출교재_바로체험해보기: {
    eventCode: 'T61-04',
    eventName: '내신관_학교별기출교재_바로체험해보기',
  },
  대시보드_퀵메뉴_선택: {
    eventCode: '',
    eventName: '[대시보드] 퀵메뉴_선택',
    eventProps: {
      메뉴명: '' as string,
      상세: '' as string,
    },
  },
  대시보드_학습지목록_학습지선택: {
    eventCode: '',
    eventName: '[대시보드] 학습지 목록_학습지 선택',
    eventProps: {
      학년: '' as string,
      직접선택: true as boolean, // True = 직접 선택 / False = 디폴트 선택
    },
  },
  대시보드_학습지성취분포_코호트선택: {
    eventCode: '',
    eventName: '[대시보드] 학습지 성취 분포_코호트 선택',
    eventProps: {
      코호트: '' as string,
    },
  },
  대시보드_생성완료_학습지일괄오답관리: {
    eventCode: '',
    eventName: '[대시보드] 생성완료_학습지일괄오답관리',
    eventProps: {
      코호트: '' as string,
      선택한_코호트_개수: 0 as number,
    },
  },
  대시보드_많이틀린문제_문제보기: {
    eventCode: '',
    eventName: '[대시보드] 많이틀린문제_문제보기',
    eventProps: {
      코호트: '' as string,
      선택한_코호트_개수: 0 as number,
      정답률: 0 as number,
      틀린학생수: 0 as number,
    },
  },
  대시보드_많이틀린문제_학생보기: {
    eventCode: '',
    eventName: '[대시보드] 많이틀린문제_학생보기',
    eventProps: {
      코호트: '' as string,
      선택한_코호트_개수: 0 as number,
      정답률: 0 as number,
      틀린학생수: 0 as number,
    },
  },

  대시보드_PV: {
    eventCode: '',
    eventName: '[대시보드] 대시보드_PV',
    eventProps: {
      '학년/반': '' as string,
      그룹선택: false,
      '학년/학기': '' as string,
      퀵메뉴_구성: [] as string[],
    },
  },

  대시보드_매트릭스_학습유형_선택: {
    eventCode: '',
    eventName: '[대시보드] 매트릭스_학습유형 선택',
    eventProps: {
      '학년/학기': '' as string,
      학습유형: '' as string,
      학생수: 0 as number,
    },
  },

  대시보드_그룹유형분석_교재_필터: {
    eventCode: '',
    eventName: '[대시보드] 그룹유형분석_교재_필터',
    eventProps: {
      교재타입: [] as string[],
      교재명: [] as string[],
    },
  },

  대시보드_그룹유형분석_성취도컬러_필터: {
    eventCode: '',
    eventName: '[대시보드] 그룹유형분석_성취도컬러_필터',
    eventProps: {
      선택한_컬러: '' as ConceptChipDomain.LevelOfAchievement,
    },
  },

  대시보드_스크롤: {
    eventCode: '',
    eventName: '[대시보드] 스크롤',
    eventProps: {
      스크롤_영역: '' as '매트릭스' | '그룹 유형분석' | '학습통계',
    },
  },
  커스텀프린팅_GNB: {
    eventCode: 'T11-01',
    eventName: 'gnb_커스텀프린팅btn',
  },
  GNB_알림아이콘btn: {
    eventCode: 'T11-01',
    eventName: 'GNB_알림아이콘btn',
  },
  커스텀프린팅Step1_닫기모달확인btn: {
    eventCode: 'T62-01',
    eventName: '커스텀프린팅Step1_닫기모달확인btn',
  },
  커스텀프린팅Step1_파일업로드btn: {
    eventCode: 'T62-01',
    eventName: '커스텀프린팅Step1_파일업로드btn',
  },
  커스텀프린팅Step1_드래그앤드롭: {
    eventCode: 'T62-01',
    eventName: '커스텀프린팅Step1_드래그앤드롭',
  },
  커스텀프린팅Step2_파일업로드: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_파일업로드',
  },
  커스텀프린팅Step2_닫기모달확인btn: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_닫기모달확인btn',
  },
  커스텀프린팅Step2_다음단계btn: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_다음단계btn',
  },
  커스텀프린팅Step2_결제하기모달주문하기btn: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_결제하기모달주문하기btn',
  },
  커스텀프린팅Step2_다른파일업로드btn: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_다른파일업로드btn',
  },
  커스텀프린팅Step2_드래그앤드롭: {
    eventCode: 'T62-02',
    eventName: '커스텀프린팅Step2_드래그앤드롭',
  },
  커스텀프린팅_진입점_교재띠배너: {
    eventCode: 'T62-03',
    eventName: '커스텀프린팅_진입점_교재띠배너',
  },
  커스텀프린팅_진입점_학습지다운로드배너: {
    eventCode: 'T62-03',
    eventName: '커스텀프린팅_진입점_학습지다운로드배너',
  },
  커스텀프린팅_진입점_학습지인쇄배너: {
    eventCode: 'T62-03',
    eventName: '커스텀프린팅_진입점_학습지인쇄배너',
  },
  커스텀프린팅_진입점_교재다운로드배너: {
    eventCode: 'T62-03',
    eventName: '커스텀프린팅_진입점_교재다운로드배너',
  },
  커스텀프린팅_진입점_교재인쇄배너: {
    eventCode: 'T62-03',
    eventName: '커스텀프린팅_진입점_교재인쇄배너',
  },
  대시보드_리스트_개별유형분석_바로가기: {
    eventCode: '',
    eventName: '[대시보드] 리스트_개별유형분석_바로가기',
    eventProps: {
      '학년/학기': '' as string,
      학습유형: '' as string,
    },
  },

  내학습지_휴지통_PV: {
    eventCode: '',
    eventName: '[내학습지] 휴지통_PV',
  },

  내학습지_휴지통_복구: {
    eventCode: '',
    eventName: '[내학습지] 휴지통_복구',
    eventProps: {
      복구_개수: 0 as number,
    },
  },
}

export const mpEventInfo = (() => {
  const obj = {}
  Object.entries(_mp_api_events).forEach(([_, event]) => {
    obj[event.eventName] = `${event.eventCode}_${event.eventName}_API`
  })
  return obj as Record<keyof typeof _mp_api_events, string>
})()

type 메인시나리오단계 = undefined | (typeof Scenario)['prototype']['id']

type 서브시나리오단계 = undefined | (typeof SubScenario)['prototype']['id']
